module.exports = __webpack_public_path__ + "img/horizontal_1_1_5010.d28a962b.png";